<app-pc-based-simulator [config]="config"></app-pc-based-simulator>
